import { IconEdit, IconTrash } from '@tabler/icons-react';

import Button from '@/components/Button/Button';

interface IFAQItemProps {
  question: string;
  answer: string;
  onEdit?: () => void;
  onDelete?: () => void;
}

const FAQItem = ({ question, answer, onEdit, onDelete }: IFAQItemProps) => {
  return (
    <div className="inline-flex w-full flex-col overflow-hidden rounded-xl outline outline-neutral-light-200 -outline-offset-1">
      {/* Header */}
      <div className="flex p-2.5 px-4 w-full items-center justify-between border-b border-neutral-light-200 bg-neutral-light-100">
        <p className="text-sm font-semibold leading-5 text-neutral-primary">
          {question}
        </p>

        <div className="flex items-center gap-4">
          <Button
            variant="outline"
            icon={<IconEdit size={16} />}
            onClick={onEdit}
            className="p-2! hover:bg-brand-default! hover:text-white! text-neutral-900 hover:border-brand-default!"
          />

          <Button
            variant="outline"
            icon={<IconTrash size={16} />}
            onClick={onDelete}
            className="p-2! hover:bg-error-default! hover:text-white! text-error-default hover:border-error-default!"
          />
        </div>
      </div>

      {/* Body */}
      <div className="flex w-full items-center p-4 faq-answer-container">
        <div
          className="text-sm font-normal leading-5 text-neutral-primary prose prose-sm max-w-none"
          dangerouslySetInnerHTML={{ __html: answer }}
          style={{
            wordBreak: 'break-word',
          }}
        />
      </div>
    </div>
  );
};

export default FAQItem;
